// @flow
//import * as React from 'react';
import Container from '../../generic/Container/Container';

class ControlsBar extends Container {
  baseClassName = 'controls-bar';
}

ControlsBar.displayName = 'ControlsBar';
export default ControlsBar;
